<div class="dp-list">
  <div class="d-flex list-top">
    <div class="col-sm-12 col-md-6 header-left">
      <span *ngIf="showFilter" class="pr-18px">
        <font-awesome (click)="onPopFilterClick($event)" [icon]="'fa-light fa-filter btn-cursor'"></font-awesome>
      </span>
      <span class="d-inline-flex total-items">
        Showing {{ totalItems || 0 | number }} Rows
      </span>
      <span *ngIf="showQ" class="pr-18px">
        <input (change)="onSearch($event)"
               [placeholder]="placeHolderForQ"
               class="form-control border-light rounded ml"
               type="search">
      </span>
      <ng-container *ngIf="openCalender">
        <div class="input-group input-calendar-condition pr-16px">
          <input
            #startDatePicker="bsDatepicker"
            [bsConfig]="bsConfig"
            [formControl]="startDate"
            [maxDate]="startMaxDate"
            bsDatepicker
            class="form-control input-search-condition py-2 pl-16px"
            placeholder="MM/DD/YYYY"
            placement="bottom"
            type="search"/>
          <span class="input-group-text bg-transparent">
                                  <img (click)="startDatePicker.toggle()"
                                       [attr.aria-expanded]="startDatePicker.isOpen"
                                       class="duration-icon"
                                       src="assets/img/ico-duration.svg"/>
                                </span>
        </div>
        <div class="input-group input-calendar-condition pr-16px">
          <input
            #endDatePicker="bsDatepicker"
            [bsConfig]="bsConfig"
            [formControl]="endDate"
            [maxDate]="today"
            bsDatepicker
            class="form-control input-search-condition py-2"
            placeholder="MM/DD/YYYY"
            placement="bottom"
            type="search"/>
          <span class="input-group-text bg-transparent">
                                  <img (click)="endDatePicker.toggle()"
                                       [attr.aria-expanded]="endDatePicker.isOpen"
                                       class="duration-icon"
                                       src="assets/img/ico-duration.svg"/>
                        </span>
        </div>
      </ng-container>

      <span (click)="goToPayment($event)" *ngIf="paymentButton" class="d-flex btn-cursor">
        <i class="fa-solid fa-credit-card mt-4px mr-4px"></i>
        <span class="ms-1">Payment</span>
      </span>
      <span *ngIf="paymentButton" class="payment-description">Please make a payment to complete the request.</span>
    </div>
    <div class="col-sm-12 col-md-6">

      <div class="pager-container">
        <span *ngIf="exportButton" class="pr-18px">
        <button (click)="exportResult($event)"
                class="btn btn-primary btn-sm"
                type="submit">Export
        </button>
      </span>
        <ng-template #popTemplate>
          <form [formGroup]="pageForm">
            <div class="form-group">
              <label for="page">Page</label>
              <input
                class="form-control form-control-sm"
                formControlName="page"
                id="page"
                max="{{ totalPages }}"
                min="0"
                type="number"
              />
            </div>
            <div class="form-group">
              <label for="pageSize">Page Size</label>
              <select class="form-control form-control-sm w-100"
                      formControlName="pageSize" id="pageSize">
                <option
                  *ngFor="let option of pageSizeOptions"
                  value="{{ option }}">
                  {{ option }} items
                </option>
              </select>
            </div>
            <div class="mt-3">
              <button (click)="onPopApplyClick($event)"
                      class="btn btn-primary btn-sm"
                      type="submit">Apply
              </button>
              <button (click)="onPopCancelClick($event)"
                      class="btn btn-default btn-sm"
                      type="submit">Cancel
              </button>
            </div>
          </form>
        </ng-template>

        <div #pop="bs-popover"
             [popover]="popTemplate"
             class="btn btn-default"
             placement="bottom">
          {{ currentPage | number }} of {{ totalPages | number }}
        </div>

        <pager
          (pageChanged)="onPageChanged($event)"
          [align]="true"
          [disabled]="spinnerService.isSpinner"
          [itemsPerPage]="itemsPerPage"
          [ngModel]="currentPage"
          [totalItems]="totalItems"
          nextText=">"
          previousText="<">
        </pager>
        <button
          (click)="toggle()"
          *ngIf="selectedItem"
          class="btn btn-default"
          type="button">
          <i [ngClass]="{'fa-outdent': showDetail && selectedItem, 'fa-indent': !showDetail}" class="fas"></i>
        </button>

      </div>

    </div>
  </div>

  <div #listContainer class="table-responsive">

    <app-no-result-table [totalItems]="totalItems" [type]="'no-result-found'"></app-no-result-table>
    <ngx-simplebar class="table-simple-bar" id="ngxSimplebar">
      <ng-content></ng-content>
    </ngx-simplebar>

    <!-- spinner in table-->
    <ngx-spinner [fullScreen]="false" bdColor="rgba(255,255,255,0.8)" color="#000000" name="table" size="default"
                 type="line-spin-clockwise-fade"></ngx-spinner>
  </div>
</div>
